export default function toLocalDateTime(date: Date, isStartDate: boolean) {
  const time = isStartDate ? '00:00:00' : '23:59:59';
  return `${date.getFullYear()}-${
    date.getMonth() + 1
  }-${date.getDate()} ${time}`;
}
